/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { Field } from "formik";
import { InputGroup } from "react-bootstrap";
import { useIntl } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCSelect from "../ucselect";

/* Styles */
import styles, {disabledStyles, airlineSelect} from "./styles.js"

const ASMembershipSelector = props => {
  const { fieldName, selectFieldName, errors, touched, providerCode, values, disabled = false } = props;
  const { formatMessage } = useIntl();

  const theme = useTheme();
  const classes = styles({ theme });


  let airlines;
  switch (providerCode) {
    default:
      airlines = [
        { "value": "AS", "label": "Atmos Rewards" },
        { "value": "AA", "label": "American Airlines" },
        { "value": "BA", "label": "British Airways" },
        { "value": "CX", "label": "Cathay Pacific" },
        { "value": "AY", "label": "Finnair" },
        { "value": "HU", "label": "Hainan Airlines" },
        { "value": "IB", "label": "Iberia" },
        { "value": "FI", "label": "Icelandair" },
        { "value": "JL", "label": "Japan Airlines" },
        { "value": "KE", "label": "Korean Air" },
        { "value": "MH", "label": "Malaysia Airlines" },
        { "value": "PD", "label": "Porter Airlines" },
        { "value": "QF", "label": "Qantas" },
        { "value": "QR", "label": "Qatar Airways" },
        { "value": "AT", "label": "Royal Air Maroc" },
        { "value": "RJ", "label": "Royal Jordanian" },
      ]
      break;
  }
  
  const filterOption = (option, inputValue) => {
    const { label, value } = option.data;
    return (
      label?.toLowerCase().includes(inputValue.toLowerCase()) ||
      value?.toLowerCase().includes(inputValue.toLowerCase())
    )
  }
  
  const customValidation = (values) => {
    let error;
    
    return error;
  };
  
  return (
    <InputGroup className={`${classes.inputGroupWrapper} ${ errors[selectFieldName] && touched[selectFieldName] || errors[fieldName] && touched[fieldName] ? "input-error" : null}`} >
      <Field
        type="text"
        name={fieldName}
        id={fieldName}
        validate={() => customValidation(values)}
        disabled={disabled}
        placeholder={formatMessage({id:"guest.mileageProgram"})}
      />
      <Field
        type="select"
        name={selectFieldName}
        id={selectFieldName}
        render={({ form }) => (
          <UCSelect
            isSearchable={true}
            styles={disabled ? disabledStyles : airlineSelect}
            options={airlines}
            defaultValue={airlines.find(
              (item) =>
                item.value === form.values[selectFieldName]
            )}
            value={form.values[selectFieldName]}
            onChange={(item) => {
              form.setFieldValue(selectFieldName, item.value)
              form.setFieldTouched(selectFieldName, true)
            }}
            filterOption={filterOption}
            disabled={disabled}
          />
        )}
      />
    </InputGroup>
  )
}

export default ASMembershipSelector;